import { PositionedModelController, PositionedModelOwnerController } from '@sas-dvr/ltjs-bird';
import { from, merge } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { filterNulls } from '../util';
import { BIRDModelControllerLoader } from './LoaderFactory';
import { EpicActions } from '../actions/epicActions';

export const loadPositionedModelOwnerController: BIRDModelControllerLoader = (
  controller,
  unload$
) => {
  if (!(controller instanceof PositionedModelOwnerController)) {
    throw new Error('Expected the controller to be a PositionedModelOwnerController');
  }

  const loadChildren$ = from(loadChildren(controller));
  const handleUnload$ = unload$.pipe(mergeMap(() => from(unloadChildren(controller))));

  return merge(loadChildren$, handleUnload$);
};

function mapChildren<T>(
  controller: PositionedModelOwnerController,
  project: (child: PositionedModelController) => T
) {
  return filterNulls(controller.getOrderedVisualAndContainerControllers()).map(project);
}

function loadChildren(controller: PositionedModelOwnerController) {
  return mapChildren(controller, EpicActions.actions.loadBirdModel);
}

function unloadChildren(controller: PositionedModelOwnerController) {
  return mapChildren(controller, EpicActions.actions.unloadBirdModel);
}
